import { useNavigate } from "react-router-dom";
import { QuitIcon } from "../../components/Icon";
import { Box, Button, Flex, Image } from "@chakra-ui/react";
import { useConfirmation } from "../../contexts/ConfirmationContext";
import { useAppDispatch } from "../../redux/store";
import { getMe } from "../../redux/reducers/auth";
import menus from "../../constants/menus";
import { useLogoutMutation } from "../../generated/graphql";
import { Fragment } from "react/jsx-runtime";
import CollapsibleMenu from "../../components/CollapsibleMenu";
import MenuItem from "../../components/MenuItem";
import React from "react";
import { SidebarMenuProps } from "./interface";

const SidebarMenu: React.FC<SidebarMenuProps> = ({ ...props }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { confirmation, setIsLoading, close } = useConfirmation();

  const [callLogout] = useLogoutMutation();

  const logout = async () => {
    setIsLoading(true);
    await callLogout();
    setIsLoading(false);
    dispatch(getMe());
    close();
    navigate("/signin");
  };

  return (
    <Flex
      flexDirection="column"
      bgColor="#1b2c59"
      overflow="auto"
      pb={6}
      h="100%"
      w="100%"
      {...props}
    >
      <Box flex={1}>
        <Box px={2} pt={2}>
          <Image src="/images/logo.png" mb="5" borderRadius="md" />
        </Box>
        {menus.map((menu) => {
          return (
            <Fragment key={menu.label}>
              {menu.items && menu.items.length >= 1 ? (
                <CollapsibleMenu menu={menu} />
              ) : (
                <MenuItem menu={menu} />
              )}
            </Fragment>
          );
        })}
      </Box>
      <Box w="full" mt="auto" px="10px">
        <Button
          _hover={{
            textDecoration: "none",
          }}
          _focus={{
            color: "#fff",
          }}
          leftIcon={<QuitIcon />}
          variant="link"
          color="#fff"
          onClick={async () => {
            confirmation({
              description: "Are you want to sign out?",
              callback: logout,
            });
          }}
        >
          <span>Sign Out</span>
        </Button>
      </Box>
    </Flex>
  );
};

export default SidebarMenu;
